import { caseFilterhash } from '@debbie/common/dist/insights';
import { h } from '../';
export const selectHome = (state) => {
    const home = state.home[caseFilterhash(state.caseFilter)];
    if (!h.hasData(home)) {
        return null;
    }
    return home.data;
};
export const selectPausedCases = (state) => {
    const pausedCases = state.pausedCases[caseFilterhash(state.caseFilter)];
    if (!h.hasData(pausedCases)) {
        return null;
    }
    return pausedCases.data;
};
//# sourceMappingURL=selectors.js.map